import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'

export interface ApiError {
  message: string
  errorCode: number
}

export interface ApiErrorResponse {
  errors: ApiError[]
}

export const transformRtkQueryError = (error: FetchBaseQueryError) => {
  return {
    status: typeof error.status === 'number' ? error.status : 500,
    errors: extractApiErrors(error),
  }
}

export const extractApiErrors = (error: FetchBaseQueryError): ApiError[] => {
  if ('data' in error && error.data) {
    const data = error.data as ApiErrorResponse
    return data.errors || []
  }
  return [{ message: 'An unknown error occurred', errorCode: 0 }]
}
